// removed by extract-text-webpack-plugin
module.exports = {"sales-opportunities-page":"sales-opportunities-page","nf-social-links":"nf-social-links","video-thumbnail-card":"video-thumbnail-card","video-thumbnail":"video-thumbnail","play-button":"play-button","video-info":"video-info","page-title":"page-title","content-container":"content-container","content-box":"content-box","lead":"lead"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/SalesOpportunities/SalesOpportunities.scss
// module id = 4323
// module chunks = 1